<template>
  <li
    class="list-item"
    :class="{
      [`list-item--flair-${flair}`]: true,
      [`list-item--size-${size}`]: true,
      'list-item--wrap': wrap,
    }"
  >
    <slot />
  </li>
</template>

<script lang="ts">
export default {
  name: 'ListItem',
}
</script>

<script setup lang="ts">
import type { PropType } from 'vue'

import { flairValidator, sizeValidator } from '@/uiKit/validators'
import type { DarwinFlairType, DarwinSizeType } from '@/uiKit/types'

// eslint-disable-next-line vue/define-props-declaration
defineProps({
  flair: {
    default: 'soft',
    type: String as PropType<DarwinFlairType>,
    validator: flairValidator,
  },
  size: {
    default: 'auto',
    type: String as PropType<DarwinSizeType>,
    validator: sizeValidator,
  },
  wrap: { default: false, type: Boolean },
})
</script>

<style lang="scss" scoped>
@import '@/uiKit/assets/borders.scss';
@import '@/uiKit/assets/heights.scss';
@import '@/uiKit/assets/spacings.scss';
@import '@/uiKit/assets/typography.scss';

.list-item {
  min-width: 50px;
  width: 100%;
  padding: $spacing-4 $spacing-3;
  list-style-type: none;
  cursor: pointer;
  @include truncate;
  @include typographyRegularBody200;

  &--wrap {
    white-space: normal;
  }

  &--flair {
    &-squared {
      border-radius: $borderRadius0;
    }

    &-soft {
      border-radius: $borderRadius8;
    }

    &-rounded {
      border-radius: $borderRadius100;
    }
  }

  &--size {
    &-auto {
      height: fit-content;
    }

    &-xs {
      height: 24px;
    }

    &-sm {
      height: 32px;
    }

    &-md {
      height: 36px;
    }

    &-lg {
      height: 40px;
    }
  }
}
</style>
